import React, { useState, useMemo } from 'react'
import { useNavigate } from 'react-router-dom'
import { C, s } from '../styles/tokens'
import { useProducts } from '../context/ProductsContext'
import ProductCard from '../components/ProductCard'

const CLINIKALLY_BRANDS = [
  'BIODERMA','CETAPHIL','CERAVE','NEUTROGENA','AVEENO','LA ROCHE-POSAY',
  'DUCRAY','URIAGE','NOREVA','SESDERMA','RILASTIL','FIXDERMA','ISDIN',
  'HELIOCARE','BENZAC','OBAGI','MESOESTETIC','EMBRYOLISSE','COOLA','PILGRIM',
]

export default function ClinikallyShop({ onOpen, onAdd }) {
  const { products: allProducts } = useProducts()
  const navigate = useNavigate()
  const [search, setSearch] = useState('')
  const [sort, setSort] = useState('')

  const products = useMemo(() => {
    let items = allProducts.filter(p =>
      CLINIKALLY_BRANDS.some(b => p.brand && p.brand.toUpperCase() === b.toUpperCase())
    )
    if (search) items = items.filter(p => p.name.toLowerCase().includes(search.toLowerCase()) || (p.brand && p.brand.toLowerCase().includes(search.toLowerCase())))
    if (sort === 'name') items = [...items].sort((a,b) => a.name.localeCompare(b.name))
    if (sort === 'price-asc') items = [...items].sort((a,b) => a.price - b.price)
    if (sort === 'price-desc') items = [...items].sort((a,b) => b.price - a.price)
    return items
  }, [search, sort])

  return (
    <div style={{background:'white',minHeight:'100vh'}}>
      <div style={{background:C.headerGrad,padding:'1.9rem 2rem 1.6rem',textAlign:'center',position:'relative',overflow:'hidden'}}>
        <div style={{position:'absolute',top:-60,right:-40,width:190,height:190,borderRadius:'50%',background:'radial-gradient(circle,rgba(133,201,154,.22),transparent 70%)',pointerEvents:'none'}}/>
        <div style={{position:'relative',zIndex:1}}>
          <div style={{fontSize:'.62rem',letterSpacing:'.2em',textTransform:'uppercase',color:'rgba(255,255,255,.45)',marginBottom:'.35rem'}}>Premium Collection</div>
          <h1 style={{fontFamily:"'DM Serif Display',serif",fontSize:'clamp(1.4rem,3vw,2rem)',color:'white',margin:'0 0 .5rem'}}>International Brands</h1>
          <p style={{color:'rgba(255,255,255,.55)',fontSize:'.9rem',maxWidth:480,margin:'0 auto'}}>
            Globally trusted, dermatologist-recommended skincare from the world's leading brands
          </p>
        </div>
      </div>

      <div style={{...s.inner,padding:'2.5rem 2rem'}}>
        <div style={{display:'flex',gap:'1rem',marginBottom:'2rem',flexWrap:'wrap'}}>
          <div style={{position:'relative',flex:1,minWidth:200}}>
            <span style={{position:'absolute',left:'1rem',top:'50%',transform:'translateY(-50%)',color:C.muted}}>🔍</span>
            <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="Search products or brands…"
              style={{width:'100%',padding:'.75rem 1rem .75rem 2.75rem',border:`1px solid ${C.border}`,borderRadius:9,fontSize:'.875rem',outline:'none',fontFamily:"'DM Sans',sans-serif",boxSizing:'border-box'}}/>
          </div>
          <select value={sort} onChange={e=>setSort(e.target.value)}
            style={{padding:'.75rem 1.25rem',border:`1px solid ${C.border}`,borderRadius:9,fontSize:'.875rem',background:'white',cursor:'pointer',outline:'none',fontFamily:"'DM Sans',sans-serif",color:C.text}}>
            <option value="">Sort by</option>
            <option value="name">Name A–Z</option>
            <option value="price-asc">Price: Low to High</option>
            <option value="price-desc">Price: High to Low</option>
          </select>
        </div>

        <div style={{display:'flex',gap:'.5rem',flexWrap:'wrap',marginBottom:'2rem'}}>
          {CLINIKALLY_BRANDS.map(brand=>(
            <button key={brand} onClick={()=>navigate('/shop',{state:{brandFilter:brand}})}
              style={{padding:'.35rem .85rem',borderRadius:999,fontSize:'.72rem',fontWeight:600,border:`1px solid ${C.border}`,background:'white',color:C.muted,cursor:'pointer',fontFamily:"'DM Sans',sans-serif",transition:'all .2s'}}
              onMouseEnter={e=>{e.currentTarget.style.borderColor=C.g500;e.currentTarget.style.color=C.g700;e.currentTarget.style.background=C.g50}}
              onMouseLeave={e=>{e.currentTarget.style.borderColor=C.border;e.currentTarget.style.color=C.muted;e.currentTarget.style.background='white'}}>
              {brand}
            </button>
          ))}
        </div>

        {products.length === 0
          ? <div style={{textAlign:'center',padding:'4rem',color:C.muted}}>No products found.</div>
          : (
            <>
              <div style={{fontSize:'.8rem',color:C.muted,marginBottom:'1.25rem'}}>{products.length} products</div>
              <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fill,minmax(220px,1fr))',gap:'1.5rem'}}>
                {products.map(p=><ProductCard key={p.id} product={p} onOpen={onOpen} onAdd={onAdd}/>)}
              </div>
            </>
          )
        }
      </div>
    </div>
  )
}
